import { createAction } from 'redux-actions';

export const SET_IS_BOTTOM = 'HELPER::SET_IS_BOTTOM';

export const setIsBottom = createAction(SET_IS_BOTTOM);
